@let stageValue = stage();
@if (stageValue === 'NotStarted') {
  <h3 class="heading-xl">{{ datesConfiguration() | stageTitle }}</h3>
  <a class="button primary" href="#">Pick dates</a>
} @else {
  <hgroup class="date-value" aria-atomic="true">
    <h3 class="heading-3xs">{{ datesConfiguration() | stageTitle }}</h3>
    <p class="heading-lg">
      {{ datesConfiguration() | dateRange }}
    </p>
  </hgroup>

  @if (isOwner()) {
    @let link = editLink();
    @if (link) {
      <a class="button secondary" [routerLink]="link">
        <div class="icon icon-edit-2"></div>
        <span class="sr-only">Edit dates</span>
      </a>
    }
  }
}
